export enum AppResourceStatus {
    Idle = 'idle',
    Loading = 'loading',
    Reloading = 'reloading',
    Error = 'error',
    Resolved = 'resolved',
    Local = 'local'
}